<template>
  <section id="contact" class="relative py-16 md:py-24 px-6 md:px-12 lg:px-24">
    <h2 class="relative text-5xl md:text-6xl lg:text-5xl font-black text-[#39ab58] text-center mb-12 z-10">
      {{ $t('contact.title') }}
    </h2>

    <div
      class="relative font-sans mx-[-1.5rem] md:mx-[-3rem] lg:mx-[-6rem] before:absolute before:w-full before:h-full before:inset-0 before:bg-black before:opacity-70 z-0">
      <img src="../assets/img/vecteezy_contact-us-or-customer-support-hotline-people-connect_13035274.webp"
        :alt="$t('contact.banner.alt')" class="absolute inset-0 w-full h-full object-cover brightness-[75%]" />

      <div class="min-h-[350px] relative z-50 h-full w-full flex flex-col justify-center p-6 lg:pl-12 " :class="{
        'items-end lg:pr-12 lg:pl-6 text-right': $i18n.locale === 'ar',
        'items-start': $i18n.locale !== 'ar'
      }">
        <div class="space-y-4 w-full" :class="{
          'text-right': $i18n.locale === 'ar',
          'text-left': $i18n.locale !== 'ar'
        }">
          <h2 class="text-3xl sm:text-4xl font-bold text-white mb-4 centeritem">{{ $t('contact.banner.title') }}</h2>
          <p class="text-lg sm:text-lg text-gray-200 whitespace-pre-wrap centeritem">{{ $t('contact.banner.description')
            }}</p>
        </div>
      </div>
    </div>

    <div class="relative flex flex-col md:flex-row justify-center items-center gap-8 z-20 -mt-[90px]">
      <!-- Email Card -->
      <div
        class="flex flex-col items-center justify-center bg-white p-8 shadow-lg rounded-lg w-64 h-80 text-center transition-all duration-300 hover:ring-1 ring-[#22c55e] group">
        <i
          class="fas fa-envelope fa-3x text-[#1A1A1A] mb-4 group-hover:text-[#22c55e] duration-300 transition-colors"></i>
        <h3 class="text-2xl font-semibold text-[#1A1A1A] mb-4">{{ $t('contact.email.title') }}</h3>
        <a class="text-lg text-gray-700 group-hover:text-[#22c55e] duration-300 transition-colors"
          href="mailto:marwan@mts.sy">
          marwan@mts.sy
        </a>
      </div>

      <!-- Phone Card -->
      <div
        class="flex flex-col items-center justify-center bg-white p-8 shadow-lg rounded-lg w-64 h-80 text-center transition-all duration-300 hover:ring-1 ring-[#22c55e] group">
        <i class="fas fa-phone fa-3x text-[#1A1A1A] mb-4 group-hover:text-[#22c55e] duration-300 transition-colors"
          :class="{ 'fa-flip-horizontal': $i18n.locale === 'ar' }"></i>
        <h3 class="text-2xl font-semibold text-[#1A1A1A] mb-4">{{ $t('contact.phone.title') }}</h3>
        <a class="text-lg text-gray-700 group-hover:text-[#22c55e] duration-300 transition-colors ltr"
          href="tel:+963987292450">
          +963 987 292 450
        </a>
      </div>

      <!-- Address Card -->
      <div
        class="flex flex-col items-center justify-center bg-white p-8 shadow-lg rounded-lg w-64 h-80 text-center transition-all duration-300 hover:ring-1 ring-[#22c55e] group">
        <i
          class="fas fa-map-marker-alt fa-3x text-[#1A1A1A] mb-4 group-hover:text-[#22c55e] duration-300 transition-colors"></i>
        <h3 class="text-2xl font-semibold text-[#1A1A1A] mb-4">{{ $t('contact.address.title') }}</h3>
        <p class="text-md text-gray-700 leading-relaxed group-hover:text-[#22c55e] duration-300 transition-colors">
          {{ $t('contact.address.value') }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactUs'
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;900&display=swap');

[dir="ltr"] h2,
[dir="ltr"] h3,
[dir="ltr"] p,
[dir="ltr"] a {
  font-family: "Poppins", sans-serif;
}

[dir="rtl"] h2,
[dir="rtl"] h3,
[dir="rtl"] p,
[dir="rtl"] a {
  font-family: "Cairo", sans-serif;
}

.ltr {
  direction: ltr;
}

@media (max-width: 768px) {
  .centeritem {
    align-items: center;
    text-align: center;

  }

  div img{
    filter: brightness(40%);
  }
}
</style>